import { Ban } from 'lucide-react'
import { useVoiceStore } from '../../stores/voiceStore'
import { banRemainingLabel } from '../../utils/banRemainingLabel'

export default function ChannelBanScreen({ channelId }: { channelId: string }) {
  const bannedInfo = useVoiceStore((s) => s.bannedInfo)
  const setBannedInfo = useVoiceStore((s) => s.setBannedInfo)
  if (!bannedInfo || bannedInfo.channelId !== channelId) return null
  const label = banRemainingLabel(bannedInfo.expiresAt)
  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-background/90 backdrop-blur-sm">
      <div className="max-w-sm w-full mx-4 rounded-2xl bg-card border border-border shadow-xl overflow-hidden">
        <div className="px-6 pt-6 pb-4 flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-destructive/15 text-destructive flex items-center justify-center mb-3"><Ban size={28} /></div>
          <div className="text-base font-semibold text-foreground">You're banned from this channel</div>
          <div className="mt-1 text-sm text-muted-foreground">{label === 'Permanent' ? 'This ban is permanent.' : `Try again later — ${label}.`}</div>
          {bannedInfo.reason && <div className="mt-2 text-xs text-muted-foreground italic">"{bannedInfo.reason}"</div>}
        </div>
        <div className="px-6 pb-5">
          <button onClick={() => setBannedInfo(null)} className="w-full py-2 rounded-lg bg-muted text-foreground hover:bg-muted/80 transition text-sm font-medium">Close</button>
        </div>
      </div>
    </div>
  )
}
